// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GbFJ4","toggle":"styles_toggle__1mjH-","preview":"styles_preview__1Whhh"};